// https://www.figma.com/file/boD0TggYqT3XDecbfHrDbC/HLDS---Styles?type=design&node-id=1-1333&mode=design&t=1dgOSA4do2vVefUL-0

export const otherColors = {
  'brand-color': {
    // colors but 500
    yellow: '#FFAF00',
    pink: '#F078AC',
    orange: '#FF5A01',
    blue: '#65C9CA',
    green: '#5EBB00',
  } as const,

  text: {
    primary: '#252B35',
    secondary: '#777B81',
    disabled: '#CACBCE',
    link: '#6367DE',
    contrast: '#FFFFFF',
  } as const,

  background: {
    primary: '#252B35',
    border: '#CACBCE',
    // black: '#000000',
    light: '#F5F5F5',
    white: '#FFFFFF',
  } as const,
};

export const colors = {
  // NOTE: every palette here must have a full 10 shades — Mantine 9's CSS-variables
  // resolver reads shade index 9 of every registered color (single-shade entries crash it).
  gray: {
    50: '#F8F8F8', // light bg
    100: '#EEEFF0',
    200: '#DCDDDF', // borders
    300: '#CACBCE', // disabled
    400: '#AEB1B4',
    500: '#93969B',
    600: '#777B81', // secondary text
    700: '#5C6068',
    800: '#40464E',
    900: '#252B35', // primary bg/text
  } as const,

  // Dark-scheme neutrals — blue-tinted near-blacks anchored on the brand black
  // (gray-900 #252B35). REDEFINES Mantine's built-in `dark` palette so every
  // dark-scheme surface Mantine paints from it (body, Card, Menu, Popover,
  // Table, …) is brand-tinted and consistent instead of Mantine's neutral grey.
  // Side effect (accepted): the app's light-mode `dark-*` accents (nav bar,
  // tooltips, avatars) re-tint from neutral #2e2e2e to brand blue-black — same
  // darkness, ~imperceptible. Consumed by Mantine's dark derivations and by the
  // dark overrides in tools/theme/src/css-variables-resolver.ts. Needs shades
  // below #252B35 (800/900) for layered page/surface depth — a deliberate
  // exception to the light "reference-only, no new shades" rule (SEMANTIC-TOKENS.md).
  dark: {
    50: '#C9CED7', // text / lightest
    100: '#AEB4C0', // dimmed
    200: '#8E96A4', // placeholder
    300: '#6C7482', // disabled text
    400: '#515A69', // border
    500: '#3B434F', // hover / elevated-2
    600: '#2F3640', // card / default surface / elevated-1
    700: '#252B35', // page floor (brand black)
    800: '#1B2029', // deeper
    900: '#12161C', // deepest
  } as const,

  // blue-purple
  primary: {
    50: '#EFF0FC',
    100: '#E0E1F8',
    200: '#C1C2F2',
    300: '#A1A4EB',
    400: '#8285E5',
    500: '#6367DE', // link
    600: '#4F52B2',
    700: '#3B3E85',
    800: '#282959',
    900: '#1E1F43',
  } as const,

  // warning
  yellow: {
    50: '#FFF7E6',
    100: '#FFEFCC',
    200: '#FFDF99',
    300: '#FFCF66',
    400: '#FFBF33',
    500: '#FFAF00',
    600: '#CC8C00',
    700: '#996900',
    800: '#664600',
    900: '#4D3500',
  } as const,

  // success
  green: {
    50: '#EFF8E6',
    100: '#DFF1CC',
    200: '#BFE499',
    300: '#9ED666',
    400: '#7EC933',
    500: '#5EBB00',
    600: '#4B9600',
    700: '#387000',
    800: '#264B00',
    900: '#1C3800',
  } as const,

  // error/destructive
  red: {
    50: '#FCE6E6',
    100: '#F9CDCD',
    200: '#F39A9A',
    300: '#EE6868',
    400: '#E83535',
    500: '#E20303',
    600: '#B50202',
    700: '#880202',
    800: '#5A0101',
    900: '#440101',
  } as const,

  // info
  blue: {
    50: '#F0FAFA',
    100: '#E0F4F4',
    200: '#C1E9EA',
    300: '#A3DFDF',
    400: '#84D4D5',
    500: '#65C9CA',
    600: '#51A1A2',
    700: '#3D7979',
    800: '#285051',
    900: '#1E3C3D',
  } as const,

  pink: {
    50: '#FEF2F7',
    100: '#FCE4EE',
    200: '#F9C9DE',
    300: '#F6AECD',
    400: '#F393BD',
    500: '#F078AC',
    600: '#C0608A',
    700: '#904867',
    800: '#603045',
    900: '#482434',
  } as const,

  orange: {
    50: '#fff0e3',
    100: '#ffdfcd',
    200: '#ffbe9b',
    300: '#ff9b64',
    400: '#fe7c37',
    500: '#fe6a1a',
    600: '#ff5a01',
    700: '#e44f00',
    800: '#cb4500',
    900: '#b13900',
  } as const,
};
